import React, { useState } from "react";
import { Clock, Calendar, X } from "lucide-react";

function EventCard({
  title = "test",
  date = "xx/xx/xx",
  time = "7:00 PM - 10:00 PM",
  description = "Join us for our biggest jackpot night of the month!",
  imageUrl = "/images/events/weekend-jackpot.jpg",
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Card */}
      <div className="w-full max-w-2xl mx-auto mb-5 rounded-[28px] bg-transparent shadow-xl overflow-hidden border border-gray-200/70">
        {/* Image */}
        <div
          className="relative w-full overflow-hidden aspect-[16/9] cursor-zoom-in"
          onClick={() => setOpen(true)}
        >
          <img
            src={imageUrl}
            alt={title}
            className="h-full w-full object-contain bg-white transition-transform hover:scale-[1.02]"
          />
        </div>

        {/* Content */}
        <div className="bg-white px-4 sm:px-8 pt-5 pb-6">
          {/* ✅ TITLE */}
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">
            {title}
          </h2>

          <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-4 text-gray-800">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#de0016] text-white">
                <Calendar />
              </div>
              <span className="text-sm sm:text-base font-medium">{date}</span>
            </div>

            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#de0016] text-white">
                <Clock />
              </div>
              <span className="text-sm sm:text-base font-medium">{time}</span>
            </div>
          </div>

          {description && (
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              {description}
            </p>
          )}
        </div>
      </div>

      {/* 🔍 Lightbox Modal */}
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/80 p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative mx-auto max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close */}
            <button
              className="absolute top-3 right-3 rounded-full bg-black/60 text-white p-2"
              onClick={() => setOpen(false)}
            >
              <X size={22} />
            </button>

            {/* ✅ TITLE IN MODAL */}
            <h2 className="text-white text-lg sm:text-xl font-semibold mb-3 text-center">
              {title}
            </h2>

            <img
              src={imageUrl}
              alt={title}
              className="max-h-[85vh] w-full object-contain rounded-xl"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default EventCard;
